import React, { PureComponent } from 'react'
import ConfidenceHoverBefore from './confidenceHoverBefore.component'
import { getOffset } from '../../utils/common'

const noop = () => undefined

const getInitialPosition = () => ({
  x: 0,
  y: 0,
})

const getConfidenceDivId = (id) => `krDetailConfidenceWrapper-mount-${id}`;
class ConfidenceFlag extends PureComponent {
  constructor (props) {
    super(props)

    this.state = {
      showPopup: false,
      position: getInitialPosition(),
      focused: false,
    }

    this.hoverEl = React.createRef()

    this.flagMouseOver = this.flagMouseOver.bind(this)
  }

  componentDidMount() {
    // for gradual opt in for new Confidence component
    if(this.props.useNewConfidenceFlag) this.initNewConfidenceFlag();
  }

  initNewConfidenceFlag() {
    const { type, id, cDate, uName, comment, classProp, label } = this.props;
    const confidenceDivId = getConfidenceDivId(id)
    const confType = type == 1 ? 'Low' : type == 2 ? "Medium" : type == 3 ? "High" : null;
    // accept confidence or try to parse confidence from old label prop
    const confidence = this.props.confidence ?? confType ?? label?.split(' ')?.[0]?.split(' ')?.[0]
    window.initConfidenceFlagComponent(confidenceDivId, {
        confidence,
        comment,
        commentDate: cDate,
        commentAuthorFullName: uName
    })
  }

  flagMouseOver () {
    const {
      ofTop,
      ofLeft,
      comment,
      hoverStateHandler = noop,
    } = this.props

    const elementRect = getOffset(this.hoverEl)

    const topValue = (ofTop || ofTop === 0) ? ofTop : elementRect.top // props.offsetTop
    const leftValue = (ofLeft || ofLeft === 0) ? ofLeft : elementRect.left // props.offsetLeft

    let mainStyle = {}

    if (topValue - $(window).scrollTop() > 250) {
      let topVal = 0

      if (comment) {
        if (comment.length < 60) {
          topVal = topValue - 99
        } else if (comment.length < 130) {
          topVal = topValue - 100
        } else if (comment.length < 180) {
          topVal = topValue - 121
        } else if (comment.length < 270) {
          topVal = topValue - 140
        } else if (comment.length < 300) {
          topVal = topValue - 180
        } else if (comment.length < 330) {
          topVal = topValue - 163
        } else if (comment.length < 380) {
          topVal = topValue - 204
        } else if (comment.length < 460) {
          topVal = topValue - 210
        } else if (comment.length > 460) {
          topVal = topValue - 220
        }
      }

      mainStyle = {
        top: topVal,
        left: leftValue - 20,
      }
    } else {
      mainStyle = {
        top: topValue + 12,
        left: leftValue - 20,
      }
    }

    this.setState({
      showPopup: true,
      position: {
        x: mainStyle.left,
        y: mainStyle.top,
      },
    })

    hoverStateHandler(true)
  }

  render () {
    const {
      type,
      id,
      classProp,
      label,
      focused,
      style,
      hoverStateHandler = noop,
    } = this.props
    const confidenceDivId = getConfidenceDivId(id);

    const { showPopup } = this.state

    let confidenceLevel = ''

    switch (type) {
      case '1':
        confidenceLevel = 'confidenceIcon-Low'
        break;
      case '2':
        confidenceLevel = 'confidenceIcon-Medium'
        break;
      case '3':
        confidenceLevel = 'confidenceIcon-High'
        break;
      default:
    }

    return this.props.useNewConfidenceFlag ? (
      <span onClick={(e) => e.stopPropagation()} style={{ display: 'inline-flex' }} id={confidenceDivId}/>
    ) : (
      <>
        <div
          aria-label={label || ''}
          className={`confidenceIcon ${classProp} ${confidenceLevel}`}
          id={`confIt-${id}`}
          onMouseEnter={this.flagMouseOver}
          onMouseLeave={() => {
            if (!focused) {
              this.setState({
                position: getInitialPosition(),
                showPopup: false,
              })

              hoverStateHandler(false)
            }
          }}
          style={style}
          // eslint-disable-next-line jsx-a11y/no-noninteractive-tabindex
          tabIndex="0"
          onFocus={() => {
            this.flagMouseOver()
            this.setState({ focused: true })
          }}
          onBlur={() => {
            this.setState({
              position: getInitialPosition(),
              showPopup: false,
              focused: false,
            })
          }}
          ref={(el) => {
            this.hoverEl = el
          }}
        >
          {showPopup && (
            <ConfidenceHoverBefore
              {...this.props}
              currentElement={this.hoverEl}
            />
          )}
        </div>
      </>
    )
  }

  /*
  Props need to be passed
  1. type - based on that picking respected svg
  */
}

export default ConfidenceFlag
